export const homeColors = {
  background: "#ffffff",
  surface: "#ffffff",
  primary: "#DBEAFE",
  primaryStrong: "#54a2fb",
  primaryLight: "#EFF6FF",
  primaryForeground: "#374151",
  text: "#111827",
  muted: "#6b7280",
  border: "#e5e7eb",
  buttonText: "#ffffff",
  cardBg: "#ffffff",
  danger: "#dc2626",
  dropIndicator: "#000000",
  overlayMuted: "rgba(17,24,39,0.4)",
  overlayDark: "rgba(0,0,0,0.5)",
  highlight: "rgba(191, 219, 254, 0.45)",
  highlightSubtle: "rgba(219, 234, 254, 0.5)",
  rowBg: "rgba(255,255,255,0.9)",
  categoryBody: "rgba(255,255,255,0.65)",
  categoryPending: "rgba(255,255,255,0.5)",
  rowPressed: "rgba(219,234,254,0.95)",
  templateBadge: "#9333ea",
} as const;

export const homeSpacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
} as const;

export const homeRadius = 12;
export const CHECKBOX_SIZE = 20;
export const TAB_BAR_HEIGHT = 90;
